/**
 *
 * Asynchronously loads the component for ReportGenerator
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ReportGenerator = lazyLoad(
  () => import('./index'),
  module => module.ReportGenerator,
);
